import { Dispatch, SetStateAction, useState } from 'react';
import { useMountStatus } from './use-mount-status';

/**
 * similar to useState, but setState is being invoked only if component is not yet unmounted
 */
const safeUseState = <S>(initialState: S | (() => S)): [S, Dispatch<SetStateAction<S>>] => {
    const useStateOutput = useState(initialState);
    const mountStatus = useMountStatus();

    const defaultDispatch = useStateOutput[1];
    const safeDispatcher = (value: SetStateAction<S>) => {
        if (mountStatus.current) {
            defaultDispatch(value);
        }
    };

    useStateOutput[1] = safeDispatcher;
    return useStateOutput;
};

export { safeUseState };